;(function () {
  'use strict'

  angular
    .module('contrast.rules')
    .directive('csProtectRuleLanguages', csProtectRuleLanguages)

  function csProtectRuleLanguages(csBetaRulesService, LanguagesService) {
    'ngInject'

    return {
      templateUrl: 'components/rules/cs-protect-rule-languages.html',
      replace: true,
      restrict: 'E',
      scope: {
        rule: '='
      },
      link: function ($scope) {
        $scope.languages = []
        _.each($scope.rule.languages, function (language) {
          var isBeta = false
          var isNew = false

          var betaRule = csBetaRulesService.getBetaRule($scope.rule.uuid)
          var newRule = csBetaRulesService.getNewRule($scope.rule.uuid)

          if (angular.isDefined(betaRule)) {
            isBeta = _.includes(betaRule.languages, language)
          }

          if (angular.isDefined(newRule)) {
            isNew = _.includes(newRule.languages, language)
          }

          $scope.languages.push({
            name: language,
            beta: isBeta,
            new: isNew,
            display: LanguagesService.getLanguage(language).display
          })
        })
        $scope.isInAllLanguages = $scope.rule.isInAllLanguages
      }
    }
  }
})()
